<template>
    <div class="download" ref="ref_download">
        <div class="header">
            <img src="@/assets/download/bridge/logo.png" class="img-logo" alt="" />
            <p class="main-title">都都GO 免费体验官活动来啦</p>
            <span class="main-desc">都都运营团队暑期送好礼啦！<br class="mobile-show">为答谢大家对都都思维产品的喜爱，都都运营团队决定开展“都都GO 暑期免费体验官”活动。</span>
            <div class="cta" @click="$router.push('/cn/download')">
                <div class="inner">
                    <p>点击下载App</p>
                    <img src="@/assets/download/bridge/arrow.svg" alt="" />
                </div>
            </div>
        </div>
        <div class="body">
            <div class="content1">
                <p class="title">免费体验时间</p>
                <p class="desc">6月21日19点-7月20日24点</p>
                <img src="@/assets/download/bridge/coupon.png" class="coupon" alt="" />
                <div class="blue">
                    <div class="button">活动对象</div>
                    <p class="desc">
                        2024年6月20日上午9点前，购买过都都思维半年卡及以上且还在有效期内的用户，均可获得价值128元的都都GO1个月免费使用权（包含7天试用)。
                    </p>
                </div>
            </div>
            <div class="content11">
                <img src="@/assets/download/bridge/content11.png" alt="" />
                <p class="desc">
                    除此之外其他用户也可参与本次活动，<br>我们为所有都都GO的新用户，提供7天免费试学。<br>快来下载体验吧！
                </p>
            </div>
            <div class="content2">
                <p class="title">体验流程</p>
                <p class="desc">需要使用和此前购买都都思维的同一手机号或 邮箱账号登陆</p>
                <ul class="process">
                    <li>
                        <img src="@/assets/download/bridge/process1.png" alt="" />
                        <div>
                            <p class="index">1</p>
                            <p class="desc">扫码下载App</p>
                        </div>
                    </li>
                    <li>
                        <img src="@/assets/download/bridge/process2.png" alt="" />
                        <div>
                            <p class="index">2</p>
                            <p class="desc">下载都都GO</p>
                        </div>
                    </li>
                    <li>
                        <img src="@/assets/download/bridge/process3.png" alt="" />
                        <div>
                            <p class="index">3</p>
                            <p class="desc">登陆账号</p>
                        </div>
                    </li>
                </ul>
            </div>
            <!-- 
            <p class="content3 desc">
                除此之外其他用户也可参与本次活动，我们为所有都都GO的新用户，<br>提供7天免费试学 快来下载体验吧！
            </p> 
            -->
            <div class="split"></div>
            <div class="content4">
                <p class="title">
                    都都App暑期一站式搞定思维、英语学习
                </p>
                <img src="@/assets/download/bridge/content4.png" alt="" />
            </div>
        </div>
        <footer>
            <div class="container">
                <p class="rights">ⓒ 2021 Enuma, Inc. All Rights Reserved.</p>
                <div>
                    <p>深圳埃努码信息技术有限公司</p>
                    <p class="v-line"></p>
                    <p style="cursor:pointer" @click="onClickFooterLink(0)">粤ICP备2022075939号</p>
                    <p class="v-line"></p>
                    <div class="ovcn" style="cursor:pointer" @click="onClickFooterLink(1)">
                        <img src="@/assets/common/icn_beiangovcn.png" alt="" />
                        <p>京公网安备 11010502050400号</p>
                    </div>
                </div>
                <p>深圳市南山区南头街道大汪山社区桃园东路1号 西海明珠花园F座2117-1</p>
            </div>
        </footer>
        <img src="@/assets/download/bridge/qr.png" class="float-qr" alt="" />
        <div class="cta float" @click="$router.push('/cn/download')">
            <div class="inner">
                <p>点击下载App</p>
                <img src="@/assets/download/bridge/arrow.svg" alt="" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CNDownload",
    mounted() {
        window.addEventListener('scroll', this.scrollHandler)   
    },
    methods: {
        scrollHandler() {
            const floatCta = this.$refs['ref_download'].querySelector('.cta.float')
            console.log(window.scrollY)
            if (window.scrollY < 700) {
                floatCta.style.bottom = '-200px'
            } else if (window.scrollY < 1750) {
                floatCta.style.bottom = '40px'
            } else {
                floatCta.style.bottom = '-200px'
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.scrollHandler)
    }
}
</script>

<style src="@/assets/download/bridge/bridge.css" scoped></style>
<style src="@/assets/membership/style.css" scoped></style>


// WEBPACK FOOTER //
// src/pages/download/Bridge.vue